"use client";

import { useRef } from "react";
import { motion, useInView, type Variants } from "framer-motion";
import React from "react";

export const fadeUp: Variants = {
  hidden: { opacity: 0, y: 32 },
  visible: (i: number = 0) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      delay: i * 0.12,
      ease: [0.22, 1, 0.36, 1],
    },
  }),
};

export const scaleIn: Variants = {
  hidden: { opacity: 0, scale: 0.92 },
  visible: (i: number = 0) => ({
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.6,
      delay: i * 0.1,
      ease: [0.22, 1, 0.36, 1],
    },
  }),
};

export function Section({
  children,
  className = "",
  id,
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
}) {
  const ref = useRef<HTMLElement>(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  return React.createElement(
    motion.section,
    {
      ref,
      id,
      initial: "hidden",
      animate: inView ? "visible" : "hidden",
      className,
    },
    children
  );
}

export const img = {
  dubaiSkyline:
    "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=1200&q=80&auto=format",
  officeTeam:
    "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=800&q=80&auto=format",
  dashboard:
    "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&q=80&auto=format",
  realEstate:
    "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=600&q=80&auto=format",
  carFleet:
    "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=600&q=80&auto=format",
  facility:
    "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600&q=80&auto=format",
  testimonial2:
    "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=200&q=80&auto=format",
};

export const agents = [
  {
    name: "Sara",
    role: "Sales Director",
    avatar:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=120&q=80&auto=format",
    color: "bg-warn",
  },
  {
    name: "Omar",
    role: "Transaction Coordinator",
    avatar:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=120&q=80&auto=format",
    color: "bg-info",
  },
  {
    name: "Layla",
    role: "Client Success",
    avatar:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=120&q=80&auto=format",
    color: "bg-ok",
  },
  {
    name: "Raj",
    role: "Operations Lead",
    avatar:
      "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=120&q=80&auto=format",
    color: "bg-highlight",
  },
];
